import { jwtDecode } from "jwt-decode";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useLocalStorage } from "react-use";
import SpiningBubbleLoading from "../components/loading/spining_bubble";
import { useQueryAccountById } from "../services/account";
import { useQueryUser } from "../services/user";
export const UserContext = createContext();
export const useUserContext = () => useContext(UserContext);
const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken, removeToken] = useLocalStorage("token");
  const [lastRead, setLastRead] = useLocalStorage("lastRead", new Date());
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  let [{ data: userData, loading: userLoading, error }, fetch] = useQueryUser();
  const intervalRef = useRef(null);

  let [{ data: accountData, loading: accountLoading }, fetchAccount] =
    useQueryAccountById();

  useEffect(() => {
    if (error && error?.response?.data?.account === null) {
      logout();
    }
  }, [error]);
  const login = ({ token }) => {
    setIsInitialLoading(true);
    setToken(token);
  };

  const logout = () => {
    setUser(null);
    removeToken();
  };

  useEffect(() => {
    if (token && !user) {
      try {
        const tokenClaims = jwtDecode(token);
        setUser({ id: tokenClaims?.id });
      } catch (error) {
        console.error("Unable to read login token:", error);
        logout();
      }
    }
  }, [token, user]);

  useEffect(() => {

    if (!userLoading && !userData && !error && user?.id) {
      console.log("userData updated!");

      fetch(user.id).catch(() => {});
    }

    // Keep the app on its loading screen while a saved session is restored.
    if (!userLoading && (userData || error || !token)) {
      setIsInitialLoading(false);
    }
  }, [userData, userLoading, user?.id, error, token]);

  // Auto-refetch user data every 1 minute (silent background refresh)
  useEffect(() => {
    if (user?.id && userData) {
      // Clear any existing interval
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }

      // Set up interval for silent refresh every 60 seconds
      intervalRef.current = setInterval(() => {
        console.log("Silent refetch user data...");
        fetch(user.id).catch((err) => {
          console.error("Silent refetch failed:", err);
        });
      }, 60000); // 60 seconds

      // Cleanup on unmount or when dependencies change
      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      };
    }
  }, [user?.id, userData]);
  return (
    <UserContext.Provider
      value={{
        user,
        login,
        logout,
        lastRead,
        setLastRead,
        refetchUserData: async () => {
          fetch(user?.id).catch(() => {});
        },
        updateBalance: async () => {
          if (user?.id) {
            fetchAccount(user?.id)
              .then((res) => {
                userData.balance = res?.data?.account?.current_balance;
              })
              .catch((error) => console.error(error));
          }
        },
        userData,
        userLoading,
        error,
      }}
    >
      {isInitialLoading ? <SpiningBubbleLoading /> : children}
    </UserContext.Provider>
  );
};

export default UserProvider;
